export enum StartOverKeys {
    Reason = "Reason",
    UserResult = "UserResult"
};